import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
//Components
import {
    List,
    Collapse,
    ListItemIcon,
    ListItemText,
    ListItem
} from "@mui/material";

//Icons
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from "react-redux";
//Actions
import { toggleSidebar } from 'Redux/actions';

const CustomCollapse = (props) => {
    const { option, Icon, noIcon, openDrawer } = props;
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const openSideBar = useSelector(state => state.commonRedux.sidebarShow);

    useEffect(() => {
        if (!openSideBar) setOpen(false);
    }, [openSideBar])

    return (
        <>
            {
                <ListItem
                    disabled={option.disabled}
                    button
                    onClick={() => {
                        if (!openSideBar && !open) dispatch(toggleSidebar(true));
                        option.subRoutes && setOpen(!open)
                    }}
                    style={{ color: 'white', padding: '8px 16px', marginLeft: 0}}
                >
                    {
                        !noIcon &&
                        <ListItemIcon className={openDrawer ? "sidebar-open" : "sidebar-close"}>
                            <Icon style={{ color: 'white' }} />
                        </ListItemIcon>
                    }

                    {openDrawer && <ListItemText style={{ paddingLeft: noIcon && 57 }} primary={option.label} />}
                    {
                        openDrawer && option.subRoutes ? open ? <ExpandLessIcon /> : <ExpandMoreIcon /> : <></>
                    }
                </ListItem>
            }
            {
                <Collapse
                    in={open}
                    timeout="auto"
                    unmountOnExit
                >
                    <List component="div" disablePadding style={{ backgroundColor: option?.color || '#1D2734' }}>
                        {
                            option.subRoutes.filter((subRoute) => !subRoute.disabled).map((subRoute, key) => {
                                return (
                                    <div  key={`sub-${key}`}>
                                        {
                                            subRoute?.subRoutes ? <CustomCollapse option={subRoute} noIcon openDrawer={openDrawer} />
                                                :
                                                <NavLink
                                                    key={`enabled-${key}`}
                                                    to={subRoute.route}
                                                    style={{ textDecoration: 'none', color: 'white' }}
                                                >
                                                    {({ isActive }) => (
                                                        <ListItem
                                                            disabled={subRoute.disabled}
                                                            button
                                                            style={{ 
                                                                color: 'white', 
                                                                background: isActive && '#142843',
                                                                padding: '8px 16px',
                                                                justifyContent: 'flex-start'
                                                            }}
                                                        >
                                                            <div style={{ paddingLeft: 57 }}>
                                                                <ListItemText primary={subRoute.label} />
                                                            </div>
                                                        </ListItem>
                                                    )}
                                                </NavLink>
                                        }
                                    </div>
                                )
                            })
                        }
                    </List>
                </Collapse>
            }
        </>
    )
}
export default CustomCollapse;